import React from "react";

const FooterSkeleton: React.FC = () => {
  return (
    <footer className="max-h-[126px] min-h-[126px]">
      <div className="dark-pink-bg-dots p-12 py-8 max-sm:p-0 flex max-sm:flex-col-reverse items-center gap-4 max-md:gap-0 min-h-[inherit]">
        <div className="h-12 w-[122px] bg-gray-300 skeleton rounded max-md:hidden"></div>

        <div className="flex items-center justify-center max-md:justify-start max-md:w-full gap-2 mx-auto max-md:p-4">
          <div className="flex items-center gap-2 max-md:gap- max-md:w-full max-sm:grid max-sm:grid-cols-[50px_1fr_50px]">
            <div></div>
            <div className="flex items-center gap-1 max-sm:justify-center">
              <div className="w-[70px] h-12 bg-gray-300 skeleton rounded"></div>
              <div className="flex flex-col gap-1">
                <div className="h-5 w-[153px] bg-gray-300 skeleton rounded"></div>
                <h6 className="text-white text-lg max-md:text-sm">
                  <div className="h-5 w-[153px] bg-gray-300 skeleton rounded"></div>
                </h6>
              </div>
            </div>
            <div className="flex items-center max-md:justify-between gap-2">
              <div className="relative h-8 w-8">
                <div className="h-8 w-8 bg-gray-300 skeleton rounded"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative max-sm:w-full max-sm:bg-blue max-sm:flex max-sm:justify-center max-sm:py-4">
          <button className="flex items-center gap-1 text-white text-lg nav-bar">
            <span className="max-sm:hidden">
              {" "}
              <div className="h-6 w-[86px] bg-gray-300 skeleton rounded"></div>
            </span>
            <div className="h-6 w-6 bg-gray-300 skeleton rounded"></div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default FooterSkeleton;
